import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42bfc5de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Untergeordnerter Ablauf", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Ablauf öffnen")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Du kannst die Ausstiege um untergeordneten Ablauf bearbeiten. Klicke dazu auf den Button \"Ablauf öffnen\". Dort können ebenfalls weitere Ausstiege hinzugefügt werden. ")
const _hoisted_5 = { class: "outlets" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_hint = _resolveComponent("md-hint")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_md_button, {
      variant: "filled",
      icon: "open_in_browser",
      onClick: _ctx.openSubFlow
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_md_hint, { icon: "info" }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.block.outlets, (outlet, k) => {
        return (_openBlock(), _createElementBlock("li", { key: k }, [
          _createElementVNode("span", null, _toDisplayString(outlet.name), 1)
        ]))
      }), 128))
    ])
  ]))
}